export default "__VITE_ASSET__r_S2IlV$__"